import React from "react";
import * as Styled from "./styles";
import { useTranslation } from "react-i18next";

interface textProps {
  title?: string;
}

const GOEmptyText = (props: textProps) => {
  const { t } = useTranslation();

  return (
    <Styled.Container>
      <Styled.Wrapper>
        {/*<Styled.EmptyText>{props.title} 데이터가 없습니다.</Styled.EmptyText>*/}
        <Styled.EmptyText>
          {props.title} {t("components.common.noData")}
        </Styled.EmptyText>
      </Styled.Wrapper>
    </Styled.Container>
  );
};

export default GOEmptyText;
